import React from 'react'
import { Link } from 'react-router-dom'

function BlogLeft() {
  return (
    <div>
      <div className="section-bg section-padding subheader" style={{ backgroundImage: 'url(/tm/react/dronyug/assets/images/subheader.jpg)' }}>
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <h1 className="text-white page-title">Blog Grid Left</h1>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Subheader End -->
    <!-- Blog Start --> */}
    <section className="section-padding section">
        <div className="container">
            <div className="row">
            <aside className="col-lg-4">
                    <div className="sidebar">
                        <div className="sidebar_inner">
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Search</h5>
                                <form action="#" method="POST">
                                    <div className="input-group">
                                        <input type="text" name="#" className="form-control form-control-custom" placeholder="Search keywords..." autoComplete="off" required=""/>
                                        <div className="input-group-append">
                                            <button type="submit">
                                                <i className="fal fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Category</h5>
                                <ul className="categories">
                                    <li>
                                        <Link to="/blog-grid">All <span>(267)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Single-Rotor Drones<span>(50)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Multi-Rotor Drones <span>(78)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Fixed-Wing Drones<span>(95)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Fixed-Wing Hybrid Drones<span>(15)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Small Drones<span>(65)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Micro Drones<span>(62)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Tactical Drones <span>(85)</span></Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Recent Post</h5>
                                <ul className="recent_post">
                                    <li>
                                        <div className="post_thumb">
                                            <Link to="/blog-details">
                                                <img src="/tm/react/dronyug/assets/images/blog/1.jpg" className="image-fit" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="post_caption">
                                            <h6 className="post_title"><Link to="/blog-details">Lorem Ipsum is simply dummy text of the printing</Link></h6>
                                            <p className="post_date">18 Jan 2024</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="post_thumb">
                                            <Link to="/blog-details">
                                                <img src="/tm/react/dronyug/assets/images/blog/2.jpg" className="image-fit" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="post_caption">
                                            <h6 className="post_title"><Link to="/blog-details">Lorem Ipsum is simply dummy text of the printing</Link></h6>
                                            <p className="post_date">15 Fab 2024</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="post_thumb">
                                            <Link to="/blog-details">
                                                <img src="/tm/react/dronyug/assets/images/blog/3.jpg" className="image-fit" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="post_caption">
                                            <h6 className="post_title"><Link to="/blog-details">Lorem Ipsum is simply dummy text of the printing</Link></h6>
                                            <p className="post_date">21 March 2024</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Tags</h5>
                                <div className="tags_cloud">
                                    <Link to="/blog-grid">All </Link>
                                    <Link to="/blog-grid">Small Drones</Link>
                                    <Link to="/blog-grid">Micro Drones</Link>
                                    <Link to="/blog-grid">Tactical Drones</Link>
                                    <Link to="/blog-grid">Fixed-Wing Drones</Link>
                                    <Link to="/blog-grid">Multi-Rotor Drones </Link>
                                    <Link to="/blog-grid">ingle-Rotor Drones</Link>
                                    <Link to="/blog-grid">Reconnaissance Drones</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </aside>
                <div className="col-lg-8">
                    <div className="row justify-content-center">
                        <article className="col-md-6">
                            <div className="post">
                                <div className="post_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/dronyug/assets/images/blog/1.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="post_caption">
                                    <div className="post_date">14 April 2024</div>
                                    <h2 className="post_title"><Link to="/blog-details">Facing problem to get solution of your queries? Here is the solution</Link></h2>
                                </div>
                            </div>
                        </article>
                       
                        <article className="col-md-6">
                            <div className="post">
                                <div className="post_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/dronyug/assets/images/blog/2.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="post_caption">
                                    <div className="post_date">05 March 2024</div>
                                    <h2 className="post_title"><Link to="/blog-details">Better solution to make your business more effective</Link></h2>
                                </div>
                            </div>
                        </article>
                       
                        <article className="col-md-6">
                            <div className="post">
                                <div className="post_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/dronyug/assets/images/blog/3.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="post_caption">
                                    <div className="post_date">25 Fab 2024</div>
                                    <h2 className="post_title"><Link to="/blog-details">Platform where your problems meet with their solution</Link></h2>
                                </div>
                            </div>
                        </article>
                       
                        <article className="col-md-6">
                            <div className="post">
                                <div className="post_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/dronyug/assets/images/blog/4.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="post_caption">
                                    <div className="post_date">29 Jan 2024</div>
                                    <h2 className="post_title"><Link to="/blog-details">Facing problem to get solution of your queries? Here is the solution</Link></h2>
                                </div>
                            </div>
                        </article>
                        
                        <article className="col-md-6">
                            <div className="post">
                                <div className="post_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/dronyug/assets/images/blog/5.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="post_caption">
                                    <div className="post_date">08 Fab 2024</div>
                                    <h2 className="post_title"><Link to="/blog-details">Better solution to make your business more effective</Link></h2>
                                </div>
                            </div>
                        </article>
                        
                        <article className="col-md-6">
                            <div className="post">
                                <div className="post_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/dronyug/assets/images/blog/6.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="post_caption">
                                    <div className="post_date">21 March 2024</div>
                                    <h2 className="post_title"><Link to="/blog-details">Platform where your problems meet with their solution</Link></h2>
                                </div>
                            </div>
                        </article>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <nav>
                                <ul className="pagination">
                                    <li className="page-item">
                                        <Link className="page-link" to="#" aria-label="Previous">
                                            <span aria-hidden="true">«</span>
                                            <span className="sr-only">Previous</span>
                                        </Link>
                                    </li>
                                    <li className="page-item active"><Link className="page-link" to="#">1</Link></li>
                                    <li className="page-item"><Link className="page-link" to="#">2</Link></li>
                                    <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                                    <li className="page-item">
                                        <Link className="page-link" to="#" aria-label="Next">
                                            <span aria-hidden="true">»</span>
                                            <span className="sr-only">Next</span>
                                        </Link>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default BlogLeft